import React from 'react';
import { SearchIcon, ShieldIcon, ClipboardCheckIcon } from 'lucide-react';
export function Offer() {
  return <section id="angebot" className="py-16 bg-white" data-id="element-375">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-376">
        <div className="text-center" data-id="element-377">
          <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl" data-id="element-378">
            Unser Angebot
          </h2>
          <p className="mt-4 text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-379">
            Das §390 Readiness-Paket für Ihre Praxis
          </p>
        </div>
        <div className="mt-12" data-id="element-380">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8" data-id="element-381">
            {/* Schritt 1 */}
            <div className="mt-4 md:mt-0" data-id="element-382">
              <div className="relative" data-id="element-383">
                <div className="absolute flex items-center justify-center h-16 w-16 rounded-md bg-blue-600 text-white text-2xl font-bold" data-id="element-384">
                  1
                </div>
                <div className="pl-20" data-id="element-385">
                  <div className="flex items-center" data-id="element-386">
                    <SearchIcon className="h-6 w-6 text-blue-600" data-id="element-387" />
                    <h3 className="ml-2 text-xl font-medium text-gray-900" data-id="element-388">
                      Analyse & Audit
                    </h3>
                  </div>
                </div>
              </div>
              <div className="mt-6 bg-blue-50 rounded-lg p-6 h-[400px] flex flex-col" data-id="element-389">
                <ul className="space-y-4 flex-grow" data-id="element-390">
                  <li className="flex items-start" data-id="element-391">
                    <svg className="h-5 w-5 text-blue-500 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-392">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-393"></path>
                    </svg>
                    <p className="ml-3 text-gray-700" data-id="element-394">
                      Prüfung aller Sicherheitsmaßnahmen (Personal, IT,
                      Prozesse)
                    </p>
                  </li>
                  <li className="flex items-start" data-id="element-395">
                    <svg className="h-5 w-5 text-blue-500 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-396">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-397"></path>
                    </svg>
                    <p className="ml-3 text-gray-700" data-id="element-398">
                      Bestandsaufnahme vorhandener Hard- und Software
                    </p>
                  </li>
                  <li className="flex items-start" data-id="element-399">
                    <svg className="h-5 w-5 text-blue-500 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-400">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-401"></path>
                    </svg>
                    <p className="ml-3 text-gray-700" data-id="element-402">
                      Überprüfung der aktuellen IT-Sicherheitsmaßnahmen
                    </p>
                  </li>
                  <li className="flex items-start" data-id="element-403">
                    <svg className="h-5 w-5 text-blue-500 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-404">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-405"></path>
                    </svg>
                    <p className="ml-3 text-gray-700" data-id="element-406">
                      Erstellung eines Maßnahmenplans mit Ampelstatus
                    </p>
                  </li>
                </ul>
              </div>
            </div>
            {/* Schritt 2 */}
            <div className="mt-4 md:mt-0" data-id="element-407">
              <div className="relative" data-id="element-408">
                <div className="absolute flex items-center justify-center h-16 w-16 rounded-md bg-blue-600 text-white text-2xl font-bold" data-id="element-409">
                  2
                </div>
                <div className="pl-20" data-id="element-410">
                  <div className="flex items-center" data-id="element-411">
                    <ShieldIcon className="h-6 w-6 text-blue-600" data-id="element-412" />
                    <h3 className="ml-2 text-xl font-medium text-gray-900" data-id="element-413">
                      Umsetzung & Härtung
                    </h3>
                  </div>
                </div>
              </div>
              <div className="mt-6 bg-blue-50 rounded-lg p-6 h-[400px] flex flex-col" data-id="element-414">
                <ul className="space-y-4 flex-grow" data-id="element-415">
                  <li className="flex items-start" data-id="element-416">
                    <svg className="h-5 w-5 text-blue-500 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-417">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-418"></path>
                    </svg>
                    <p className="ml-3 text-gray-700" data-id="element-419">
                      Einrichtung von Backup- und Update-Management
                    </p>
                  </li>
                  <li className="flex items-start" data-id="element-420">
                    <svg className="h-5 w-5 text-blue-500 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-421">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-422"></path>
                    </svg>
                    <p className="ml-3 text-gray-700" data-id="element-423">
                      Schulung der Mitarbeitenden zu IT-Sicherheitsthemen
                    </p>
                  </li>
                  <li className="flex items-start" data-id="element-424">
                    <svg className="h-5 w-5 text-blue-500 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-425">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-426"></path>
                    </svg>
                    <p className="ml-3 text-gray-700" data-id="element-427">
                      Absicherung der E-Mail-Kommunikation und Netzwerke
                    </p>
                  </li>
                  <li className="flex items-start" data-id="element-428">
                    <svg className="h-5 w-5 text-blue-500 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-429">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-430"></path>
                    </svg>
                    <p className="ml-3 text-gray-700" data-id="element-431">
                      Cloud-Anbieterprüfung und Netzwerksegmentierung
                    </p>
                  </li>
                </ul>
              </div>
            </div>
            {/* Schritt 3 */}
            <div className="mt-4 md:mt-0" data-id="element-432">
              <div className="relative" data-id="element-433">
                <div className="absolute flex items-center justify-center h-16 w-16 rounded-md bg-blue-600 text-white text-2xl font-bold" data-id="element-434">
                  3
                </div>
                <div className="pl-20" data-id="element-435">
                  <div className="flex items-center" data-id="element-436">
                    <ClipboardCheckIcon className="h-6 w-6 text-blue-600" data-id="element-437" />
                    <h3 className="ml-2 text-xl font-medium text-gray-900" data-id="element-438">
                      Doku & Nachweis
                    </h3>
                  </div>
                </div>
              </div>
              <div className="mt-6 bg-blue-50 rounded-lg p-6 h-[400px] flex flex-col" data-id="element-439">
                <ul className="space-y-4 flex-grow" data-id="element-440">
                  <li className="flex items-start" data-id="element-441">
                    <svg className="h-5 w-5 text-blue-500 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-442">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-443"></path>
                    </svg>
                    <p className="ml-3 text-gray-700" data-id="element-444">
                      Alle Anforderungen der KZBV werden nachvollziehbar
                      dokumentiert
                    </p>
                  </li>
                  <li className="flex items-start" data-id="element-445">
                    <svg className="h-5 w-5 text-blue-500 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-446">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-447"></path>
                    </svg>
                    <p className="ml-3 text-gray-700" data-id="element-448">
                      Sie erhalten ein „Readiness-Zertifikat" (optional)
                    </p>
                  </li>
                  <li className="flex items-start" data-id="element-449">
                    <svg className="h-5 w-5 text-blue-500 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-450">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-451"></path>
                    </svg>
                    <p className="ml-3 text-gray-700" data-id="element-452">
                      Erstellung von Prozessdokumentationen und Richtlinien
                    </p>
                  </li>
                  <li className="flex items-start" data-id="element-453">
                    <svg className="h-5 w-5 text-blue-500 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-454">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-455"></path>
                    </svg>
                    <p className="ml-3 text-gray-700" data-id="element-456">
                      Unterstützung bei jährlicher Nachprüfung
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-16 bg-blue-50 rounded-lg p-8 shadow-sm" data-id="element-457">
          <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-458">
            Ihre Vorteile auf einen Blick
          </h3>
          <div className="grid md:grid-cols-2 gap-6" data-id="element-459">
            <div className="flex items-start" data-id="element-460">
              <div className="flex-shrink-0" data-id="element-461">
                <div className="flex items-center justify-center h-10 w-10 rounded-md bg-blue-600 text-white" data-id="element-462">
                  <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-463">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-464"></path>
                  </svg>
                </div>
              </div>
              <div className="ml-4" data-id="element-465">
                <h4 className="text-lg font-medium text-gray-900" data-id="element-466">
                  Rechtssicherheit
                </h4>
                <p className="mt-2 text-gray-600" data-id="element-467">
                  Erfüllung aller gesetzlichen Anforderungen gemäß §390 SGB V
                </p>
              </div>
            </div>
            <div className="flex items-start" data-id="element-468">
              <div className="flex-shrink-0" data-id="element-469">
                <div className="flex items-center justify-center h-10 w-10 rounded-md bg-blue-600 text-white" data-id="element-470">
                  <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-471">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-472"></path>
                  </svg>
                </div>
              </div>
              <div className="ml-4" data-id="element-473">
                <h4 className="text-lg font-medium text-gray-900" data-id="element-474">
                  Zeitersparnis
                </h4>
                <p className="mt-2 text-gray-600" data-id="element-475">
                  Wir übernehmen die komplette Umsetzung – Sie können sich auf
                  Ihre Patienten konzentrieren
                </p>
              </div>
            </div>
            <div className="flex items-start" data-id="element-476">
              <div className="flex-shrink-0" data-id="element-477">
                <div className="flex items-center justify-center h-10 w-10 rounded-md bg-blue-600 text-white" data-id="element-478">
                  <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-479">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-480"></path>
                  </svg>
                </div>
              </div>
              <div className="ml-4" data-id="element-481">
                <h4 className="text-lg font-medium text-gray-900" data-id="element-482">
                  Expertenwissen
                </h4>
                <p className="mt-2 text-gray-600" data-id="element-483">
                  Profitieren Sie von unserer langjährigen Erfahrung im Bereich
                  IT-Sicherheit für Zahnarztpraxen
                </p>
              </div>
            </div>
            <div className="flex items-start" data-id="element-484">
              <div className="flex-shrink-0" data-id="element-485">
                <div className="flex items-center justify-center h-10 w-10 rounded-md bg-blue-600 text-white" data-id="element-486">
                  <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-487">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-488"></path>
                  </svg>
                </div>
              </div>
              <div className="ml-4" data-id="element-489">
                <h4 className="text-lg font-medium text-gray-900" data-id="element-490">
                  Nachhaltiger Schutz
                </h4>
                <p className="mt-2 text-gray-600" data-id="element-491">
                  Langfristige Absicherung Ihrer Praxis durch regelmäßige
                  Überprüfungen und Updates
                </p>
              </div>
            </div>
          </div>
          <div className="mt-8 text-center" data-id="element-492">
            <a href="#kontakt" className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-493">
              Jetzt unverbindlich beraten lassen
            </a>
          </div>
        </div>
      </div>
    </section>;
}